import React from 'react';
import Lottie from 'react-lottie';
import animationData from './generate-ai.json'

const defaultOptions = {
  loop: true,
  autoplay: true, 
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const GenerateByAiLoader = () => {
  return (
    <Lottie options={defaultOptions}
    height={32}
              width={32}
    />
  )
}

export default GenerateByAiLoader
